
export const getMarketplaceUrl = () => {
  switch (process.env.REACT_APP_ENV) {
    case 'development':
      return 'https://dev.ujamaa.digital/artwork/';
    case 'qa':
      return 'https://qa.ujamaa.digital/artwork/';
    case 'production':
      return 'https://app.ujamaa.digital/artwork/';
    default:
      return 'https://dev.ujamaa.digital/artwork/';
  }
};
